import { risSession } from '../../session';
import type { AssistantApi } from '../api';
import { type SendMode, sendMode, toolAvailable } from './logic';
import { noTools, type ToolKey, type ToolSwitches } from './shapes';

/**
 * The org's tool switches for this page (`GET /ris/v1/ai/tools`, read once when the Asistente
 * installs). Until ris answers, and when it cannot (an older ris without the route), every round-3
 * tool is off and "Copiar al informe" keeps copying: hiding is never the gate (ris re-checks every
 * route), but a tool the org did not switch on must not be offered.
 */

let switches: ToolSwitches = noTools();

function perms(): readonly string[] {
  return risSession()?.perms ?? [];
}

export async function loadSwitches(api: AssistantApi): Promise<ToolSwitches> {
  try {
    switches = await api.tools();
  } catch (error) {
    console.warn('[viewer] assistant tool switches unavailable', error);
    switches = noTools();
  }
  return switches;
}

/** The tool is on for the org and the session may use it. */
export function toolOn(key: ToolKey): boolean {
  return toolAvailable(switches, perms(), key);
}

/** ris answered 409 errors.ai.tool_disabled: the org switched it off since the page opened. */
export function markToolOff(key: ToolKey): void {
  switches = { ...switches, tools: { ...switches.tools, [key]: false } };
}

export function reportSendMode(): SendMode {
  return sendMode(switches, perms());
}

